import * as mutation from "./mutation-types";
import { stateMerge } from "vue-object-merge";
import { getBlankRecord } from "./helpers";
import { getInitialState, getUnloadedState } from "./state";

export const mutations = {
  [mutation.STATE_RESET](state) {
    stateMerge(state, getInitialState());
  },
  [mutation.STATE_UNLOAD](state, onlyUnloadListing = false) {
    if (onlyUnloadListing) {
      state.listing.loaded = false;
    } else {
      stateMerge(state, getUnloadedState());
    }
  },
  [mutation.STATE_HIDE_ERROR](state, hideArgument) {
    stateMerge(state[hideArgument], { error: { show: false } });
  },

  [mutation.LIST_SET_PAGING](state, paging) {
    stateMerge(state.listing.paging, paging);
  },
  [mutation.LIST_SET_CRITERIA_DESCRIPTION](state, criteriaInfo) {
    state.listing.criteriaInfo = criteriaInfo;
  },
  [mutation.LIST_STARTED](state) {
    state.listing.loading = true;
  },
  [mutation.LIST_FAILED](state) {
    state.listing.loading = false;
  },
  [mutation.LIST_SUCCEEDED](state, logs) {
    state.listing.loading = false;
    state.listing.loaded = true;
    state.listing.data = logs;
  },

  [mutation.VIEW_NEXT](state, next) {
    stateMerge(state.view.next, next);
  },
  [mutation.VIEW_PREVIOUS](state, previous) {
    stateMerge(state.view.previous, previous);
  },
  [mutation.VIEW_CLEAR](state) {
    state.view.loading = false;
    state.view.loaded = false;
    state.view.data = getBlankRecord();
  },
  [mutation.VIEW_STARTED](state, roleId) {
    state.view.loading = true;
    state.view.roleId = roleId;
  },
  [mutation.VIEW_FAILED](state) {
    state.view.loading = false;
    state.view.loaded = false;
  },
  [mutation.VIEW_SUCCEEDED](state, role) {
    state.view.loading = false;
    state.view.loaded = true;
    stateMerge(state.view.data, role);
    state.view.breadcrumbs = [];
    state.view.breadcrumbs.push({
      text: "Roles & permissions",
      path: "/roles"
    });
    state.view.breadcrumbs.push({
      text: role.name
    });
  },

  [mutation.EDIT_INITIALISE_FOR_CREATE](state) {
    state.edit.loading = false;
    state.edit.isNew = true;
    state.edit.data = getBlankRecord();
  },
  [mutation.EDIT_SET_DATA](state, details) {
    stateMerge(state.edit.data, details);
  },
  [mutation.EDIT_GET_STARTED](state) {
    state.edit.loading = true;
    state.edit.error.show = false;
    state.edit.isNew = false;
    state.edit.data = getBlankRecord();
  },
  [mutation.EDIT_GET_FAILED](state) {
    state.edit.loading = false;
  },
  [mutation.EDIT_GET_SUCCEEDED](state, provider) {
    state.edit.loading = false;
    stateMerge(state.edit.data, provider);
  },

  [mutation.EDIT_SAVE_STARTED](state) {
    state.edit.saving = true;
    state.edit.error.show = false;
  },
  [mutation.EDIT_SAVE_FAILED](state, error) {
    state.edit.saving = false;
    state.edit.error.show = true;
    state.edit.error.details = error;
  },
  [mutation.EDIT_SAVE_SUCCEEDED](state, provider) {
    state.edit.saving = false;
    stateMerge(state.edit.data, provider);
  },

  [mutation.DELETE_INITIALISE](state) {
    state.delete.saving = false;
  },
  [mutation.EDIT_DELETE_STARTED](state, id) {
    state.delete.id = id;
    state.delete.saving = true;
  },
  [mutation.EDIT_DELETE_FAILED](state) {
    state.delete.saving = false;
  },
  [mutation.EDIT_DELETE_SUCCEEDED](state) {
    state.delete.saving = false;
  },

  [mutation.EXPORT_STARTED](state) {
    state.exportToExcel.processing = true;
  },
  [mutation.EXPORT_FAILED](state) {
    state.exportToExcel.processing = false;
  },
  [mutation.EXPORT_SUCCEEDED](state) {
    state.exportToExcel.processing = false;
  }
};
